module.exports = __webpack_public_path__ + "assets/img/coin-gct-bj-2.5c4b7540.png";